(function (global) {
        'use strict';

        /**
         * Устанавливает защиту от редактирования текста внутри переменных
         * @param {string} selector - CSS-селектор текстового поля
         * @description Добавляет обработчик события input, который проверяет позицию каретки
         * и откатывает изменения, если каретка находится внутри переменной (между фигурными скобками).
         * Если каретка в допустимой позиции - изменения сохраняются.
         */
        const _protectionRegistry = new WeakMap();

        function setupTextChangeProtection(selector) {
            let oField = document.querySelector(selector);
            if (!oField)
                return;

            // Если обработчики уже установлены - просто синхронизируем previousValue
            if (_protectionRegistry.has(oField)) {
                _protectionRegistry.get(oField).previousValue = oField.value;
                return;
            }

            const state = { previousValue: oField.value, previousCaretPos: 0 };
            _protectionRegistry.set(oField, state);

            // Сохраняем состояние перед изменением
            oField.addEventListener('beforeinput', function () {
                state.previousValue = oField.value;
                state.previousCaretPos = getCaretPosition(oField);
            });

            // Проверяем и откатываем при необходимости
            oField.addEventListener('input', function () {
                const isInVariable = !isCaretInVariableField(oField);

                if (isInVariable) {
                    // Каретка внутри переменной - откатываем изменение
                    oField.value = state.previousValue;
                    // Восстанавливаем позицию каретки
                    if (oField.setSelectionRange) {
                        oField.setSelectionRange(state.previousCaretPos, state.previousCaretPos);
                    }
                } else {
                    // Каретка в допустимой позиции - принимаем изменение
                    state.previousValue = oField.value;
                }
            });
        }

        /**
         * Вставляет текст в позицию курсора в указанном текстовом поле
         * @param {string} selector - CSS-селектор текстового поля
         * @param {string} text - Текст для вставки
         * @returns {boolean} - true, если вставка успешна, false в противном случае
         * @description Функция проверяет корректность позиции курсора перед вставкой
         * и генерирует событие input для оповещения слушателей об изменении
         */
        function insertTextAtCaret(selector, text) {
            let correct = isCaretInVariable(selector)
            if (!correct)
                return false;
            let oField = document.querySelector(selector);
            let caretPos = getCaretPosition(selector);
            let textAreaTxt = oField.value;

            oField.value = textAreaTxt.substring(0, caretPos) + text + textAreaTxt.substring(caretPos);
            let event = new Event('input', {bubbles: true});
            oField.dispatchEvent(event);
            return true;
        }

        /**
         * Получает текущую позицию курсора в текстовом поле
         * @param {string} fieldOrSelector - CSS-селектор текстового поля
         * @returns {number} - Позиция курсора (индекс символа)
         * @description Учитывает направление выделения текста, если оно есть
         */
        function getCaretPosition(fieldOrSelector) {
            let oField = (typeof fieldOrSelector === 'string') ? document.querySelector(fieldOrSelector) : fieldOrSelector;
            if (!oField)
                return 0;

            let iCaretPos = 0;

            if (oField.selectionStart || oField.selectionStart === 0)
                iCaretPos = oField.selectionDirection === 'backward' ? oField.selectionStart : oField.selectionEnd;

            return iCaretPos;
        }

        /**
         * Проверяет, находится ли курсор внутри переменной (между фигурными скобками)
         * @param {string} oField - CSS-селектор текстового поля
         * @returns {boolean} - true, если курсор находится в допустимой позиции, false в противном случае
         * @description Анализирует текст слева и справа от курсора на наличие открывающих и закрывающих скобок,
         * чтобы определить, находится ли курсор внутри структуры переменной
         */
        function isCaretInVariableField(oField) {
            if (!oField) return true;
            const caretPos = getCaretPosition(oField);
            const text = oField.value;

            // Ищем первый { или } слева от каретки (идём назад)
            let leftCorrect = true;
            for (let i = caretPos - 1; i >= 0; i--) {
                if (text[i] === '}') { leftCorrect = true; break; }
                if (text[i] === '{') { leftCorrect = false; break; }
            }

            // Ищем первый { или } справа от каретки (идём вперёд)
            let rightCorrect = true;
            for (let i = caretPos; i < text.length; i++) {
                if (text[i] === '{') { rightCorrect = true; break; }
                if (text[i] === '}') { rightCorrect = false; break; }
            }

            return leftCorrect && rightCorrect;
        }

        function isCaretInVariable(selector) {
            let oField = document.querySelector(selector);
            return isCaretInVariableField(oField);
        }

        /**
         * Удаляет переменную при нажатии клавиши Backspace
         * @param {string} selector - CSS-селектор текстового поля
         * @description Обрабатывает удаление переменной при нажатии Backspace.
         * Если курсор находится сразу после закрывающей скобки '}' переменной,
         * функция удаляет всю переменную целиком (формат {{имя}}).
         * Также корректирует одиночные открывающие скобки '{', преобразуя их в '{{'.
         */
        function removeVariableOnBackspace(selector) {
            let oField = document.querySelector(selector);
            let caretPos = getCaretPosition(selector);
            let text = oField.value.toString();
            let leftText = text.slice(0, caretPos)
            let rightText = text.slice(caretPos, text.length)

            if (rightText.length !== 0 && rightText.startsWith('{') && !rightText.startsWith('{{'))
                rightText = rightText.replace(/^\{/, '{{');


            if (leftText.length !== 0 && leftText.endsWith('}') && !rightText.startsWith('}'))
                leftText = leftText.replace(/\{\{([^}]+)}$/, '')

            oField.value = `${leftText}${rightText}`
        }

        /**
         * Удаляет переменную при нажатии клавиши Delete
         * @param {string} selector - CSS-селектор текстового поля
         * @description Обрабатывает удаление переменной при нажатии Delete.
         * Если курсор находится непосредственно перед открывающей скобкой '{' переменной,
         * функция удаляет всю переменную целиком (формат {{имя}}).
         * Также корректирует одиночные закрывающие скобки '}', преобразуя их в '}}'.
         */
        function removeVariableOnDelete(selector) {
            let oField = document.querySelector(selector);
            let caretPos = getCaretPosition(selector);
            let text = oField.value.toString();
            let leftText = text.slice(0, caretPos)
            let rightText = text.slice(caretPos, text.length)

            if (leftText.length !== 0 && leftText.endsWith('}') && !leftText.endsWith('}}'))
                leftText = leftText.replace(/}$/, '}}');

            if (rightText.length !== 0 && rightText.startsWith('{') && !rightText.startsWith('{{') && !leftText.endsWith('{'))
                rightText = rightText.replace(/^\{([^}]+)}}/, '')

            oField.value = `${leftText}${rightText}`
        }

        /**
         * Устанавливает стиль логотипа в зависимости от названия приложения
         * @param {string} appName - Название приложения (например, 'EFTR.Advisory.Admin' или 'EFTR.Admin')
         * @description Функция создает и добавляет элемент <style> в head документ,
         * который определяет внешний вид логотипа через CSS-класс .header-logo.
         */
        function setLogo(appName) {
            const isAdvisory = appName === 'EFTR.Advisory.Admin';

            const logoADVLight = 'Logo_adv.svg';
            const logoADVDark = 'Logo_adv_dark.svg';

            const favicon = isAdvisory ? 'favicon_adv.ico' : 'favicon.ico';
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
                link = document.createElement('link');
                link.rel = 'icon';
                document.head.appendChild(link);
            }
            link.href = favicon;

            const style = document.createElement('style');
            if (isAdvisory) {
                const themeLink = document.getElementById('xaf-current-theme');
                const isDark = themeLink?.href.includes('dark');
                const logoADV = isDark ? logoADVDark : logoADVLight;
                style.textContent = `
                    .header-logo {
                        flex-shrink: 0;
                        background: url('../images/${logoADV}') center/contain no-repeat transparent;
                        width: 100%;
                        height: 22px;
                        max-width: 164px;
                    }
                `;
            } else
                style.textContent = `
                    .header-logo {
                        flex-shrink: 0;
                        background-color: currentColor;
                        -webkit-mask:  url('../images/Logo.svg');
                        mask:  url('../images/Logo.svg');
                        -webkit-mask-position: center;
                        mask-position: center;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        width: 164px;
                        height: 18px;
                    }`;

            const updateLogo = () => {
                document.querySelectorAll('.header-logo').forEach(() => {
                    if (isAdvisory) {
                        const themeLink = document.getElementById('xaf-current-theme');
                        const isDark = themeLink?.href.includes('dark');
                        const logoADV = isDark ? logoADVDark : logoADVLight;
                        style.textContent = `
                            .header-logo {
                                flex-shrink: 0;
                                background: url('../images/${logoADV}') center/contain no-repeat transparent;
                                width: 100%;
                                height: 22px;
                                max-width: 164px;
                            }
                        `;
                    }
                });
            }

            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'childList') {
                        mutation.addedNodes.forEach(node => {
                            if (node.id === 'xaf-current-theme' ||
                                (node.tagName === 'LINK' && node.id === 'xaf-current-theme'))
                                updateLogo();
                        });
                    }
                });
            });

            observer.observe(document.head, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['href']
            });

            document.head.appendChild(style);
        }

        // Экспорт функций в глобальную область видимости
        global.setLogo = setLogo;
        global.insertTextAtCaret = insertTextAtCaret;
        global.isCaretInVariable = isCaretInVariable;
        global.removeVariableOnDelete = removeVariableOnDelete;
        global.removeVariableOnBackspace = removeVariableOnBackspace;
        global.setupTextChangeProtection = setupTextChangeProtection;

    }

)
(window);